import { createSelector } from 'reselect';
import { getMachineSettings } from './getMachineSettings';

export const getPromptOperatorForPartCountMultiplier = createSelector(
  [getMachineSettings],
  (machineSettings) => {
    return machineSettings?.operatorPcmOverrideEnabled ?? false;
  }
);
